import React, { useState, useEffect } from 'react';
import logo from '../assets/zizi-pickleball-logo.png';
import { HashLink } from 'react-router-hash-link';
import { useTranslation } from 'react-i18next';
// The import for 'dropdown-promo.jpg' has been completely removed.

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { t, i18n } = useTranslation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Handles adding/removing a class to the body to prevent scrolling when the menu is open.
  // Using useEffect is the correct way to handle side-effects in React.
  useEffect(() => {
    if (isMenuOpen) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }
    return () => document.body.classList.remove('no-scroll'); // Cleanup on unmount
  }, [isMenuOpen]);

  const handleLanguageChange = (lang) => {
    i18n.changeLanguage(lang);
  };

  return (
    <div className={`header-container ${isMenuOpen ? 'open' : ''}`}>
      <header className="new-header">
        <div className="header-content">
          <div className="header-left-controls">
            <button className="hamburger-menu" onClick={toggleMenu}>
              <span />
              <span />
              <span />
            </button>
            <HashLink to="/#top" smooth className="logo-container" onClick={() => setIsMenuOpen(false)}>
              <img src={logo} alt="Zizi Pickleball Logo" className="header-logo" />
            </HashLink>
          </div>

          <div className="language-switcher">
            <button onClick={() => handleLanguageChange('en')} className={i18n.language === 'en' ? 'active' : ''}>
              EN
            </button>
            <span className="lang-separator">/</span>
            <button onClick={() => handleLanguageChange('hr')} className={i18n.language === 'hr' ? 'active' : ''}>
              HR
            </button>
          </div>

          <div className="header-right-controls">
            <a href="https://play1more.com/zizi-pickleball" target="_blank" rel="noopener noreferrer" className="btn-book-now">
              {t('bookNow')}
            </a>
          </div>
        </div>
      </header>

      {/* The navigation overlay */}
      <nav className="header-nav" onClick={toggleMenu}>
        <div className="dropdown-container" onClick={(e) => e.stopPropagation()}>
          {/* The nav-promo div has been deleted from here. */}
          <div className="nav-links">
            <ul>
                <li><HashLink smooth to="/#top" onClick={toggleMenu}>{t('nav.top')}</HashLink></li>
                <li><HashLink smooth to="/#how-to-play" onClick={toggleMenu}>{t('nav.howToPlay')}</HashLink></li>
                <li><HashLink smooth to="/#about-us" onClick={toggleMenu}>{t('nav.aboutUs')}</HashLink></li>
                <li><HashLink smooth to="/#services" onClick={toggleMenu}>{t('nav.services')}</HashLink></li>
                <li><HashLink smooth to="/#contact" onClick={toggleMenu}>{t('nav.contact')}</HashLink></li>
                <li><HashLink smooth to="/#location" onClick={toggleMenu}>{t('nav.location')}</HashLink></li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
};
//                <li><HashLink smooth to="/#membership" onClick={toggleMenu}>Membership</HashLink></li>
//                <li><HashLink smooth to="/#testimonials" onClick={toggleMenu}>Testimonials</HashLink></li>
export default Header;